import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireApproved, RequireOwner } from "@/context/guards";
import GamesPage from "@/pages/GamesPage";

// Everything except the home grid + auth boot is lazy-loaded to keep the
// initial JS payload small.
const GamePlayerPage = lazy(() => import("@/pages/GamePlayerPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const RegisterPage = lazy(() => import("@/pages/RegisterPage"));
const PendingPage = lazy(() => import("@/pages/PendingPage"));
const ChatPage = lazy(() => import("@/pages/ChatPage"));
const CommunityGamesPage = lazy(() => import("@/pages/CommunityGamesPage"));
const GameMakerPage = lazy(() => import("@/pages/GameMakerPage"));
const PartyPage = lazy(() => import("@/pages/PartyPage"));
const SuggestPage = lazy(() => import("@/pages/SuggestPage"));
const OwnerPanel = lazy(() => import("@/pages/OwnerPanel"));

const RouteFallback = () => (
  <div className="min-h-screen bg-[#fff7f0] grid place-items-center text-[#5c534d] text-sm">
    Loading…
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/pending" element={<PendingPage />} />
              <Route path="/" element={<RequireApproved><GamesPage /></RequireApproved>} />
              <Route path="/game/:slug" element={<RequireApproved><GamePlayerPage /></RequireApproved>} />
              <Route path="/chat" element={<RequireApproved><ChatPage /></RequireApproved>} />
              <Route path="/suggest" element={<RequireApproved><SuggestPage /></RequireApproved>} />
              <Route path="/community" element={<RequireApproved><CommunityGamesPage /></RequireApproved>} />
              <Route path="/gamemaker" element={<RequireApproved><GameMakerPage /></RequireApproved>} />
              <Route path="/party" element={<RequireApproved><PartyPage /></RequireApproved>} />
              <Route path="/owner" element={<RequireOwner><OwnerPanel /></RequireOwner>} />
            </Routes>
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
